import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* LOGO — EXACT SPLIT COLOR */}
        <Link to="/" className="text-lg font-semibold tracking-tight">
          <span className="text-gray-900">TechX </span>
          <span className="text-blue-700">Incorporation</span>
        </Link>

        {/* DESKTOP NAV */}
        <nav className="hidden md:flex items-center gap-8 text-gray-700 font-medium">
          <Link to="/" className="hover:text-blue-700 transition">
            Home
          </Link>
          <Link to="/training" className="hover:text-blue-700 transition">
            Corporate Training
          </Link>
          <Link to="/solutions" className="hover:text-blue-700 transition">
            IT Solutions
          </Link>
          <Link to="/contact" className="hover:text-blue-700 transition">
            Contact
          </Link>
        </nav>

        {/* DESKTOP CTA — EXACT */}
        <Link
          to="/contact"
          className="hidden md:inline-flex bg-blue-700 text-white px-5 py-2 rounded-lg font-semibold hover:bg-blue-800 transition"
        >
          Request Consultation
        </Link>

        {/* MOBILE TOGGLE */}
        <button
          className="md:hidden text-gray-700 text-xl"
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <nav className="flex flex-col px-6 py-6 space-y-4 text-gray-700 font-medium">
            <Link to="/" onClick={() => setOpen(false)}>Home</Link>
            <Link to="/training" onClick={() => setOpen(false)}>Corporate Training</Link>
            <Link to="/solutions" onClick={() => setOpen(false)}>IT Solutions</Link>
            <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>

            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-4 bg-blue-700 text-white px-5 py-3 rounded-lg font-semibold text-center"
            >
              Request Consultation
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
